export default {
  namespaced: true,
  state: {
    videoThumbnailStatus: false
  },
  mutations: {
    setVideoThumbnailStatus(state, payload) {
      state.videoThumbnailStatus = payload
    }
  },
  actions: {
    setVideoThumbnailStatus({ commit }, value) {
      commit('setVideoThumbnailStatus', value)
    }
  },
  getters: {
    videoThumbnailStatus: state => state.videoThumbnailStatus
  }
}
